import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import toast from "react-hot-toast";
import apis from "../../../../lib/apis/apis";
import {apiHeaders, apiHeadersImage} from "../../../../lib/apiHeader";
import { getClinicsEvents } from '../clinics-events';

export const getAllClinicsServices = createAsyncThunk('getAllClinicsServices', async ({ provider_id, category_id }, { dispatch }) => {
  //console.log("Provider ID:", provider_id);
    try {
      // Start with the base URL
      let baseUrl = apis.get_service + `${provider_id}`;
      let queryString = `&page=1&limit=1500`;
  
      // Append category_id to the query string if it's provided and in array format
      if (Array.isArray(category_id)) {
        category_id.forEach((value, index) => {
          queryString +=` &category_ids[${index}]=${encodeURIComponent(value)}`;
        });
      } else if (category_id) {
        // If category_id is not an array, just append it
        queryString +=` &category_ids=${encodeURIComponent(category_id)}`;
      }
  
      // Construct the full URL with the manually built query string
      let url = baseUrl + queryString;
  
      // Now make the API call with the constructed URL
      const response = await axios.get(url, { // Use the full URL string
        headers: apiHeaders()
      });
  
      if (response?.data?.success === 'true') {
        return response?.data?.data;
      } else if (response?.data?.success === false) {
        return {
          data: response.data,
          errors: true
        };
      }
    } catch (err) {
      if (err?.response?.status !== 200) {
        return {
          data: [],
          errors: err?.response?.data?.errors
        };
      }
    }
  });

// Answers only "does this clinic have any services at all?". AddStaff used to
// dispatch getAllClinicsServices for this — limit=1500 with five eager-loaded
// relations — and then read nothing but .length off the result. Resolves to
// true/false, or null when the request failed, so callers can tell "no services"
// apart from "could not ask".
export const getClinicServicesExist = createAsyncThunk('getClinicServicesExist', async ({ provider_id }) => {
    try {
        const response = await axios.get(apis.get_service + provider_id + '&page=1&limit=1', {
            headers: apiHeaders()
        });

        if (response?.data?.success === 'true') {
            const data = response?.data?.data;
            return Array.isArray(data) ? data.length > 0 : Boolean(data);
        }
        return null;
    } catch (err) {
        return null;
    }
});

// `limit`/`page` are optional overrides. Callers that know their own page size
// should pass it: reading pageLimit from the store meant a caller could pick up a
// *different* screen's page size if that screen dispatched updateserviceFilter
// while this call was still being set up. Switching Active Services <-> Promotions
// quickly did exactly that — the Active tab fetched with the Promotions tab's
// limit=500 and rendered every service with no pagination.
export const  getClinicsServices = createAsyncThunk('getClinicsServices', async ({ provider_id, category_id, is_promo, limit, page } , { getState, dispatch }) => {
    const { search, pageLimit, currentPage } = getState().clinicServicesStore;
    const effectiveLimit = limit ?? pageLimit;
    const effectivePage = page ?? currentPage;
    try {

      let baseUrl = apis.get_clinic_services + `${provider_id}`;
      let queryString = `&page=${effectivePage}&limit=${effectiveLimit}`;

      if (search !== '') {
        queryString += `&search=${encodeURIComponent(search)}`;
      }

      if (is_promo) {
        queryString += `&is_promo=1`;
      }
       
      if (Array.isArray(category_id)) {  
        category_id.forEach((value, index) => {
          queryString += `&category_ids[${index}]=${encodeURIComponent(value)}`;
        });
      } else if (category_id) {
        queryString += `&category_ids=${encodeURIComponent(category_id)}`;
      }   
  
      let url = baseUrl + queryString;  
    
      const response = await axios.get(url, { 
        headers: apiHeaders()
      });
  
      if (response?.data?.success === 'true') {
        return response?.data?.data;
      } else if (response?.data?.success === false) {
        return {
          data: response.data,
          errors: true
        };
      }
    } catch (err) {
      if (err?.response?.status !== 200) {
        return {
          data: [],
          errors: err?.response?.data?.errors
        };
      }
    }
  });
export const storeClinicsServices = createAsyncThunk('storeClinicsServices', async (data, {dispatch}) => {
    try {
        const response = await axios.post(apis.store_clinics_service, data?.data,{
            headers: apiHeadersImage()
        })
        if (response?.data?.success ==='true'){
          await  dispatch( getClinicsServices({provider_id:data.provider_id, currentPage:"1"}))
            toast.success("Services added successfully",{duration:3000})
        }
        return  response?.data

    }catch (err){
        if (err?.response?.status!==200){
            toast.error(err?.message,{duration:4000})
        }
        if (err?.response?.status!==200){

            return {
                data : [],
                errors:err?.response?.data?.errors
            }
        }
    }  
})


// 




export const UpdateServices = createAsyncThunk('UpdateServices', async ( {serviceId,data}, {dispatch}) => {
    try {
        const response = await axios.post(`${apis.update_service}/${serviceId}`, data?.data,{
            headers: apiHeadersImage()
        })
        if (response?.data?.success ==='true'){
          if (data.provider_id) {
            await dispatch(getClinicsServices( {provider_id:data.provider_id, currentPage:"1"}));
          } else {
            console.error("Provider ID is undefined");
          }
          // await  dispatch( getClinicsServices(data.provider_id))
            toast.success("Services added successfully",{duration:3000})
        }
        return  response?.data

    }catch (err){
        if (err?.response?.status!==200){
            toast.error(err?.message,{duration:4000})
        }
        if (err?.response?.status!==200){
 
            return {
                data : [],
                errors:err?.response?.data?.errors
            }
        }
    }
})

// 
export const getClinicsServicesByID = createAsyncThunk('getClinicsServicesByID', async (id) => {
    try {
        const response = await axios.get(apis.get_service_by_id+id,{
            headers: apiHeaders()
        })
        return  response?.data

    }catch (err){
        if (err?.response?.status!==200){
            return {
                data : [],
                errors:err?.response?.data?.errors
            }
        }
    }
}) 


export const getServiceBundel = createAsyncThunk('getServiceBundel', async (id) => {
  try {
      const response = await axios.get(apis.get_Bundle+id,{
          headers: apiHeaders()
      })
      return  response?.data?.data 

  }catch (err){
      if (err?.response?.status!==200){
          return {
              data : [],
              errors:err?.response?.data?.errors 
          }
      }
  }
}) 


// 
export const updateClinicsServices = createAsyncThunk('updateClinicsServices', async ( {provider_id,data}, { dispatch }) => {
    try {
        const response = await axios.post( `${apis.update_clinics_service}?provider_id=${provider_id}`, data, {
              
            headers: apiHeadersImage()       
        })
     
        if (response?.data?.success === 'true') {
          if (data.provider_id) {
            await dispatch(getClinicsServices( {provider_id:data.provider_id, currentPage:"1"}));
          } else {
            console.error("Provider ID is undefined");
          }
            
            toast.success("Services updated successfully", { duration: 3000 })

            return response.data
        } else {
            return response?.data
        }
    } catch (err) {   
        if (err?.response?.status !== 200) {
            toast.error(err?.message, { duration: 4000 })
        }
        if (err?.response?.status !== 200) {
            return {
                data: err?.response,
                errors: true
            }
        }
    }
})

export const deleteClinicsServices = createAsyncThunk('deleteClinicsServices', async (data,{dispatch}) => {
    try {
        const response = await axios.get(apis.delete_clinic_service+data?.id,{
            headers: apiHeaders()
        })
   
        if (response?.data?.success ==='true'){
          if (data.provider_id) {
            await dispatch(getClinicsServices({ provider_id: data.provider_id ,currentPage:"1"})); 
              await dispatch(getClinicsEvents({ provider_id: data.provider_id ,currentPage:"1"}));
            
          } else {
            console.error("Provider ID is undefined");
          }
            // await dispatch(getClinicsServices(data?.provider_id))
            toast.success("Clinic services deleted successfully",{duration:3000})

        }else {
        }  
  
    }catch (err){
        if (err?.response?.status!==200){    
          //console.log("message",err)
            toast.error(err?.response?.data?.errors,{duration:4000})   
        }   
    }
})

export const updateServicePrice = async (itemId, priceType, newPrice) => {
    try {
        const response = await fetch(`${BACKEND_URL}services/update-price/${itemId}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                ...apiHeaders(),
            },
            body: JSON.stringify({
                [priceType]: newPrice,
            }),
        });
        const data = await response.json();
        if (data.success) {
            //console.log("Price updated successfully");
        } else {
            console.error("Failed to update price");
        }
    } catch (error) {
        console.error("Error updating price", error);
    }
};


export const updateserviceFilter = createAsyncThunk('updateserviceFilter', async (data) => {
    return data
})

export const clinicsServicesSlice = createSlice({
    name: 'clinicsServicesSlice',
    initialState: {
        services: [],
        allServices: [],
        // null until asked; see getClinicServicesExist.
        hasServices: null,
        latestRequestId: null,
        meta: {},
        links: {},
        search:'',
       Bundel:[],
        pageLimit:12,
        currentPage:1,
        Promos:[],
    },
    reducers: {
    }, 
    extraReducers: builder => {
        // Kept OUT of `services`. This thunk fetches limit=1500 for callers that
        // need the whole list at once (AddStaff's "does this clinic have any
        // services" check). Writing it into `services` clobbered the paginated
        // grid: it replaced a 12-row page with all 287 rows and a meta of
        // last_page:1, so the Active Services pagination disappeared.
        builder.addCase(getAllClinicsServices.fulfilled, (state, action) => {
            state.allServices = action.payload
        })

        builder.addCase(getClinicServicesExist.fulfilled, (state, action) => {
            state.hasServices = action.payload
        })

 
            // Last request wins. Overlapping fetches (fast tab switching, typing
            // then paginating) resolve out of order, and a slow earlier response
            // used to land last and replace the correct one — e.g. a stale
            // limit=500 payload overwriting the current limit=12 page, which
            // dropped meta.last_page to 1 and hid the pagination. Track the newest
            // requestId on pending and ignore every fulfillment that isn't it.
            builder.addCase(getClinicsServices.pending, (state, action) => {
                state.latestRequestId = action.meta.requestId;
            })

            builder.addCase(getClinicsServices.fulfilled, (state, action) => {
                if (action.meta.requestId !== state.latestRequestId) return;
                state.services = action.payload
                state.meta = action.payload.meta
                state.links = action.payload.links
                state.currentPage = action.payload?.meta?.current_page;

            })
            
            // Bundles are a separate list — it must not touch the services grid's
            // pagination. It used to write meta/links/currentPage, and since the
            // bundle payload carries no meta that set currentPage to undefined,
            // which then went out on the wire as `&page=undefined`.
            builder.addCase(getServiceBundel.fulfilled, (state, action) => {
              state.Bundel = action.payload
          })
            // 
         
            //
        // getClinicsServices
        builder.addCase(updateserviceFilter.fulfilled, (state, action) => {
            const { search, pageLimit, currentPage } = action.payload; 
            if (pageLimit){
                state.pageLimit = pageLimit ;
            } 
            if (search){
                state.search = search === 'reset' ? '' : search ;
            }
            if (currentPage){
                state.currentPage = currentPage ;
            }
            
           
        });
        
    }
})


export default clinicsServicesSlice.reducer